import {createSelector} from 'reselect'

const getLicensesState = state => state.licenses.common

export const getPricingModelType = createSelector(
    getLicensesState,
    licensesState => licensesState.pricingModelType
)

export const getLicenses = createSelector(
    getLicensesState,
    licensesState => licensesState.licenses
)

export const isLoading = createSelector(
    getLicensesState,
    (licensesState) => licensesState.loading
)

export const isFirstLoading = createSelector(
    getLicensesState,
    (licensesState) => licensesState.firstLoading
)

export const getCurrentUsedUser = createSelector(
    getLicensesState,
    (licensesState) => licensesState.currentUsedUser
)

export const getLicensedToInfo = createSelector(
    getLicensesState,
    (licensesState) => licensesState.licensedTo
)

export const getPaymentMethod = createSelector(
    getLicensesState,
    (licensesState) => licensesState.paymentMethod
)

export const getSavedCardInfo = createSelector(
    getLicensesState,
    (licensesState) => licensesState.cardInfo
)

export const isHavePurchases = createSelector(
    getLicensesState,
    (licensesState) => licensesState.havePurchases
)

export const getDocumentsBaseUrl = createSelector(
    getLicensesState,
    (licensesState) => licensesState.documentsBaseUrl
)

export const getLastLicenseType = createSelector(
    getLicenses,
    (licenses) => licenses && licenses.length ? licenses[licenses.length - 1].type : ''
)

export const getCountries = createSelector(
    getLicensesState,
    licensesState => licensesState.countries
)

export const getStatesByCountry = createSelector(
    getLicensesState,
    licensesState => licensesState.statesByCountry
)

export const getMaxUsersToUnlimited = createSelector(
    getLicensesState,
    (licensesState) => licensesState.maxUsersToUnlimited
)

export const getMaxFreeUsers = createSelector(
    getLicensesState,
    (licensesState) => licensesState.maxFreeUsers
)

export const getUnavailableInFreeFeatures = createSelector(
    getLicensesState,
    (licensesState) => licensesState.unavailableInFreeFeatures
)

export const getMinWireTransferAmount = createSelector(
    getLicensesState,
    (licensesState) => licensesState.minWireTransferAmount
)

export const getUsersLowerLimit = createSelector(
    getLicensesState,
    (licensesState) => licensesState.usersLowerLimit
)


// WEBPACK FOOTER //
// ./web/js/administration/licenses/selectors.js